import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';

import { HHTeamInvitationSelect } from './fields';
import { FORM_NAME } from '../forms/formConstant';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      email: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string()
      }).required(translate('form.error.mixed.required'))
    }),
  mapPropsToValues: () => ({ email: '' }),
  handleSubmit: (values, { props, resetForm, setSubmitting }) => {
    props
      .handleSubmit(values)
      .then(() => {
        resetForm({ email: '' });
      })
      .then(() => {
        setSubmitting(false);
      });
  },
  displayName: FORM_NAME.CMS_EMAIL_FORM
});

const TeamInvitationForm = props => {
  const {
    handleSubmit,
    isSubmitting,
    title,
    translate,
    loadOptions,
    optionRenderer
  } = props;
  const placeholder = 'kent@xxx.com';

  return (
    <Form className='cms-attendees_form' onSubmit={handleSubmit}>
      <Form.Field>
        <p className='cms-attendees_form_heading'>{title}</p>
        <label>{translate('single.email.form.instruction')}</label>
        <div className='cms-attendees_form_fieldGroup ui action'>
          <Field
            name='email'
            component={HHTeamInvitationSelect}
            otherProps={{
              id: 'email',
              className: 'cms-attendees_form_fieldGroup_input',
              placeholder,
              loadOptions,
              searchable: true,
              clearable: false,
              optionRenderer
            }}
          />

          <Button
            disabled={isSubmitting}
            loading={isSubmitting}
            className={
              !isSubmitting
                ? 'cms-attendees_form_fieldGroup_submit ui button primary'
                : 'cms-attendees_form_fieldGroup_submit ui button'
            }
            type='submit'
          >
            {translate('invite')}
          </Button>
        </div>
      </Form.Field>
    </Form>
  );
};

TeamInvitationForm.defaultProps = {
  loadOptions: () => {},
  optionRenderer: null
};

export default compose(
  withLocalize,
  formikEnhancer,
)(TeamInvitationForm);



// WEBPACK FOOTER //
// ./src/components/forms/teamInvitationForm.js